const togglePassword = function () {
    const togglePassword = function () {
        const passwords = $('input[type=password]');
        passwords.each(function(i, obj) {
            $(obj).addClass('toggle').parent().append("<span class='togglePassword position-absolute btn'>&emsp;</span>");
        });

        $('.togglePassword').on( "click", function() {
            const password = $(this).parent().find('input')[0];
            const type = password.getAttribute("type") === "password" ? "text" : "password";
            password.setAttribute("type", type);
            this.classList.toggle("password-toggle");
        });
    };

    return {
        init: function () {
            togglePassword();
        }
    };
}();

jQuery(document).ready(function () {
    togglePassword.init();
});